import { cn } from '#/lib/utils';

/**
 * 單據明細「行備註」Textarea：手機約 2～3 行；≥@3xl 對齊同列 FloatingInput／SelectCore（3.125rem）。
 */
export const LINE_REMARK_TEXTAREA_CLASS = cn(
  'min-h-16 w-full resize-y',
  '@3xl/form-section:h-[3.125rem] @3xl/form-section:min-h-[3.125rem]',
  '@3xl/form-section:resize-none @3xl/form-section:overflow-y-auto',
  '@3xl/form-section:py-2 @3xl/form-section:field-sizing-fixed',
);
